var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwalThinkingFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.51 79.9148C21.7828 79.9148 0.5 67.5411 0.5 40.3896C0.5 13.2382 21.7828 0.864459 41.51 0.864459C52.4696 0.864459 62.5807 4.47051 70.0756 11.0463C78.2069 18.2584 82.52 28.4402 82.52 40.3896C82.52 52.3391 78.2069 62.4502 70.0756 69.6623C62.5807 76.238 52.3989 79.9148 41.51 79.9148Z",
    fill: "url(#paint0_radial_1_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.51 79.9148C21.7828 79.9148 0.5 67.5411 0.5 40.3896C0.5 13.2382 21.7828 0.864459 41.51 0.864459C52.4696 0.864459 62.5807 4.47051 70.0756 11.0463C78.2069 18.2584 82.52 28.4402 82.52 40.3896C82.52 52.3391 78.2069 62.4502 70.0756 69.6623C62.5807 76.238 52.3989 79.9148 41.51 79.9148Z",
    fill: "url(#paint1_linear_1_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3715 16.8937C79.1402 22.9745 81.1059 30.2149 81.1059 38.2684C81.1059 50.2179 76.7927 60.329 68.6615 67.5411C61.1665 74.1168 50.9847 77.7936 40.0959 77.7936C27.3262 77.7936 13.9343 72.5966 6.02928 61.5734C13.6373 74.0602 27.9484 79.9148 41.51 79.9148C52.3989 79.9148 62.5807 76.238 70.0756 69.6623C78.2069 62.4502 82.52 52.3391 82.52 40.3896C82.52 31.3816 80.0665 23.3775 75.3715 16.8937Z",
    fill: "#EB8F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M1.12222 49.0229C1.82929 47.1775 4.95453 47.1492 7.26665 48.2664C11.7424 50.4371 11.2121 55.1886 13.4535 56.136C15.6949 57.0835 22.7727 51.2785 32.7211 50.3593C33.8383 50.2532 40.4353 49.426 41.0858 52.1977C41.3403 53.2936 39.4736 53.5057 39.4736 53.5057C35.4292 55.0047 31.3141 56.532 27.6939 58.9007C23.5858 61.5805 19.9939 65.3704 15.2212 66.4875C13.3616 66.9188 11.2616 66.8552 9.74846 65.7027C7.86766 64.2885 7.45049 61.6936 6.76463 59.438C5.97978 56.8572 4.68585 54.4532 2.97474 52.3674",
    fill: "url(#paint2_linear_1_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03737 49.0159C-0.249493 50.5785 2.48686 54.729 2.97474 56.8431C4.14848 61.9481 2.97474 63.2067 2.88282 67.7461C2.80504 72.738 4.29696 76.938 8.10099 79.6178C11.6788 82.1562 15.6171 82.4461 21.1323 80.8198C26.6474 79.1936 30.3737 78.4087 30.6565 75.6936C30.812 74.5693 30.2181 73.4663 29.1858 72.9855C29.7373 72.7239 30.1757 72.2784 30.4232 71.7198C31.7383 68.5805 29.1151 67.9158 29.1151 67.9158C29.4757 67.4845 29.7797 67.0108 30.0201 66.5017C30.805 64.939 30.6777 62.8178 28.4151 62.1249C27.3757 61.8067 27.0929 61.9764 27.0929 61.9764C28.1676 60.8734 29.4545 59.9896 30.8757 59.3956C34.6797 57.7623 39.1908 56.7724 40.3151 55.8179C41.9484 54.4037 42.0474 51.6815 39.1625 50.8684C35.0191 49.6522 27.3969 52.4805 22.7585 55.429C18.1202 58.3774 13.8636 59.9684 12.4495 59.431C11.0353 58.8936 10.1586 58.0168 9.62119 55.8956C8.62422 51.9502 7.85352 50.4229 6.16362 48.9451C4.76363 47.7431 2.02727 47.8138 1.03737 49.0159Z",
    fill: "url(#paint3_radial_1_16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0313 64.3451C24.0313 64.3451 22.9919 63.638 27.1424 60.3219C29.9706 58.0522 31.604 57.6421 34.9908 56.7865C41.8353 55.1108 41.4039 52.9542 41.4039 52.9542C41.7716 56.129 38.6322 56.836 36.3343 57.5572C36.0939 57.628 35.8676 57.7199 35.6272 57.7764C27.7575 59.7845 25.007 64.9744 24.0313 64.3451Z",
    fill: "url(#paint4_linear_1_16)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4797 72.2148C31.0949 71.1966 31.2646 69.9592 30.9393 68.8138C30.7131 68.1421 30.2817 67.5552 29.6949 67.1522C29.7797 67.039 29.8646 66.933 29.9424 66.8057C30.5716 65.8229 30.6636 64.5855 30.1898 63.5178C29.6525 62.6764 28.7757 62.1178 27.7929 61.9906C28.4646 62.3158 28.9666 62.9168 29.1646 63.638C29.2777 64.5077 29.1504 65.3986 28.811 66.2047C28.3585 67.3077 27.3474 68.0784 26.1666 68.234C24.4555 68.5734 24.9787 69.2805 24.9787 69.2805C25.1272 69.8461 27.1494 69.3229 28.6838 68.1774C29.1151 68.4037 29.4403 68.7926 29.5959 69.2522C29.7585 69.9663 29.6595 70.7229 29.3201 71.3734C28.8464 72.4128 27.9272 73.1905 26.8242 73.4946C25.304 73.9118 25.7211 74.4703 25.7211 74.4703C25.7211 74.4703 25.7919 75.6724 28.9171 73.6926C29.2848 74.3996 29.7727 75.9764 28.7969 76.9946C25.4878 80.4804 15.7373 81.8239 15.7373 81.8239C20.6868 81.8239 27.4888 79.9148 29.5959 78.1683C30.4161 77.5249 30.8969 76.5491 30.904 75.5097C30.9959 74.541 30.6353 73.5794 29.9353 72.9006C30.1333 72.6885 30.3171 72.4623 30.4797 72.2148Z",
    fill: "url(#paint5_linear_1_16)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8928 46.3361C50.6665 46.2936 50.4544 46.2017 50.2777 46.0532C47.0888 43.4937 43.2847 41.825 39.2474 41.2027C35.21 40.5027 31.0666 40.8846 27.2272 42.3058C27.0151 42.3906 26.7888 42.4189 26.5626 42.3836C26.0676 42.2987 25.6646 41.931 25.5302 41.4431C25.3959 40.9623 25.5585 40.4533 25.9403 40.1351C33.4353 33.9129 44.5504 34.9452 50.7726 42.4401C51.2817 43.0553 51.7484 43.7058 52.1726 44.3775C52.4413 44.7947 52.4413 45.332 52.1726 45.7492C51.8968 46.1805 51.3948 46.4068 50.8928 46.3361Z",
    fill: "#422B0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6504 17.9119C56.613 17.9119 59.3069 20.4149 59.3069 24.5725C59.3069 28.73 56.613 31.226 53.6504 31.226C50.6878 31.226 47.9938 28.723 47.9938 24.5725C47.9938 20.422 50.6878 17.9119 53.6504 17.9119Z",
    fill: "#422B0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1646 11.4705C26.202 11.4705 23.508 13.9735 23.508 18.124C23.508 22.2745 26.202 24.7846 29.1646 24.7846C32.1343 24.7846 34.8211 22.2816 34.8211 18.124C34.8211 13.9664 32.1343 11.4705 29.1646 11.4705Z",
    fill: "#422B0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6323 3.43112C24.3141 2.90789 24.2717 2.25738 24.5191 1.6988C24.7878 1.14022 25.3181 0.758398 25.9333 0.680621C29.7868 0.0796119 33.7181 0.991731 36.9141 3.219C38.109 4.0392 39.1696 5.02909 40.0676 6.16748C40.1241 6.23818 40.1736 6.31596 40.2231 6.40081C40.7039 7.1503 40.5413 8.1402 39.8484 8.69878C39.106 9.31393 38.0171 9.29272 37.3029 8.64222L37.5999 8.16141L37.2393 8.58565C34.1423 5.99778 30.2676 4.52001 26.2373 4.3998C25.5656 4.3998 24.9434 4.04627 24.604 3.46647L24.6323 3.43112Z",
    fill: "#422B0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2978 16.0806C62.8211 15.7907 63.1746 15.2604 63.2453 14.6664C63.2877 14.0513 63.0261 13.4574 62.5382 13.0826C59.4766 10.6432 55.5877 9.47656 51.6918 9.84423C50.2494 9.96444 48.8352 10.3038 47.4918 10.8483L47.2373 10.9685C46.4524 11.3856 46.1059 12.326 46.4312 13.1533C46.7777 14.0513 47.7181 14.5604 48.6585 14.3553V13.7897L48.7575 14.3412C52.717 13.6058 56.811 14.221 60.3817 16.0877C60.9685 16.42 61.6827 16.42 62.2695 16.0877L62.2978 16.0806Z",
    fill: "#422B0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.51 40.3896) scale(40.2744 40.2744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_16",
    x1: 41.51,
    y1: 79.9148,
    x2: 41.51,
    y2: 0.864459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FDE030",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_16",
    x1: 21.269,
    y1: 71.1542,
    x2: 21.0923,
    y2: 47.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8484 54.8216) scale(41.8656 39.3536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_16",
    x1: 24.315,
    y1: 62.8267,
    x2: 42.1261,
    y2: 53.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DA6727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_16",
    x1: 23.3943,
    y1: 80.3886,
    x2: 23.5427,
    y2: 53.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DA6727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwalThinkingFace);
export default __webpack_public_path__ + "static/media/swal_thinking_face.a09eb84abe208ae2b7c5c39c69d684d8.svg";
export { ForwardRef as ReactComponent };